// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__RMk3l","dragIcon":"SortableItem_dragIcon__dvp1i","disabled":"SortableItem_disabled__21gh-"};